<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Aneks nr 1</strong></br>
    <strong>Do umowy o współpracy z dnia {{ dataPodpisania }} r.</strong>
</p>
<p>
    Zawarty w dniu {{ aktualnaData() }} r. w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
 <strong>Tutore Sp. z o.o.</strong>  z siedzibą w Łodzi (90-440), ul. Piotrkowska 157A, zarejestrowaną 
 w Rejestrze Przedsiębiorców pod numerem KRS 0000867745, REGON: 387448002, NIP: 7272846163, kapitał zakładowy: 5 000 zł, sąd rejestrowy: Sąd Rejonowy dla Łodzi-Śródmieścia w Łodzi,</br>
 XX Wydział Gospodarczy – Krajowego Rejestru Sądowego, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>,
</p> 
<p>a</p>

<p><strong>Zleceniobiorcą:</strong></p>
  <br/>
  Nazwa firmy: {{ nazwaFirmy }}
  <br/>
  Siedziba firmy: {{ siedzibaFirmy }}
  <br/>
  NIP: {{ nip }}
  <br/>
  REGON: {{ regon }}
  <br/>
</br>
  <p> zwanymi dalej łącznie <strong>"Stronami"</strong>, zaś z osobna - <strong>"Stroną"</strong>,</p>
  <p>o następującej treści:</p>
<p>Zważywszy na to, że Umowa o współpracę z dnia {{ dataPodpisania }} r. (dalej: Umowa) zawiera oczywistą omyłkę pisarską w treści komparycji, konieczne stało się zawarcie niniejszego aneksu (dalej: Aneks).</p>

<p align="center" style="margin-bottom: 0px;">
</br>
  <strong>§ 1</strong>
</p>
</br>
          <p>Strony zmieniają Umowę w ten sposób, że od dnia jej zawarcia, tj. od {{ dataPodpisania }} r., komparycja Umowy obowiązuje w następującym brzmieniu:</p>
        </br>
          <p><strong>Zleceniodawcą:</strong></p>
          <p><strong>Tutore Sp. z o.o. </strong> z siedzibą w Łodzi (90-440), ul. Piotrkowska 157A, zarejestrowaną w Rejestrze Przedsiębiorców pod numerem KRS 0000867745, REGON: 387448002, NIP: 7272846163, kapitał zakładowy: 5 000 zł, sąd rejestrowy: Sąd Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Gospodarczy – Krajowego Rejestru Sądowego, reprezentowaną przez:
          </p>
          <p>{{ zamawiajacy }}</p>
          <p>a</p>
          <p><strong>Zleceniobiorcą:</strong></p>
          Nazwa firmy: {{ nazwaFirmy }}
          <br/>
          Siedziba firmy: {{ siedzibaFirmy }}
          <br/>
          NIP: {{ nip }}
          <br/>
          REGON: {{ regon }}
          <br/>
          <br/>          

<p align="center" style="margin-bottom: 0px;">
</br>
  <strong>§ 2</strong>
</p>
</br>
<p>Strony potwierdzają, że pozostałe warunki Umowy nie ulegają zmianie i obowiązują od {{ dataPodpisania }} r. w tym samym brzmieniu, a Strony zobowiązują się je przestrzegać.</p>        

<p align="center" style="margin-bottom: 0px;">
</br>
  <strong>§ 3</strong>
</p>
</br>
<ol type="b">
          <li>Wszelkie zmiany i uzupełnienia warunków Aneksu wymagają zgodnej woli Stron wyrażonej w formie dokumentowej.</li>
          <li>Aneks został sporządzony w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze Stron.</li>
          <li>Do spraw nieuregulowanych w Aneksie mają zastosowanie odpowiednie przepisy prawa polskiego.</li>
          <li>Ewentualny spór wynikający z Aneksu będzie rozstrzygany przez Strony najpierw w drodze ugodowej, a dopiero w przypadku niemożliwości jego polubownego rozstrzygnięcia przez sąd powszechny właściwy dla siedziby Zleceniodawcy.</li>
        </ol>
      </br>
    </br>
  </br>


<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{ zamawiajacy }}</span><br>
        <span style="margin-left: 0%;">Zleceniodawca</span>
    </div>
    <div class="right-cointainer">
        {{ imieNazwisko }}<br>
        <span style="margin-left: 0%;">Zleceniobiorca</span>
    </div>
</div>

  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'AneksPorozumienieB2B',
  data () {
    return {
      numerUmowy:'',
      zamawiajacy: '',
      imieNazwisko: '',
      pesel: '',
      zamieszkany: '',
      zmiana: '',
      dataAneks: '',
      numerUmowy: '',
      dataPodpisania: '',
      stawka: '',
      stawkaSlownie: '',
      nazwaFirmy: '',
      siedzibaFirmy: '',
      nip: '',
      regon: '',
    };
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    aktualnaData() {
      const today = new Date();
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = today.getDate()+'-'+month+'-'+today.getFullYear()
      return todayDate
    },
    teacherWage(index) {
      return index > 1 ? Number(this.stawka) + 5 * (index - 1) : this.stawka;
    },
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
}

.wage-table {
  border: 1px solid; 
  font-size: 12px; 
  width: 65%;
  margin: 20px;
}

.wage-table caption {
  text-align: left; 
}

.wage-table td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  font-weight: bold;
  text-align: center;
}

ol.special {
    counter-reset: list;
}
ol.special > li {
    list-style: none;
    position: relative;
}
ol.special > li:before {
    counter-increment: list;
    content: counter(list) ") ";
    position: absolute;
    left: -1.4em;
}
</style>



// WEBPACK FOOTER //
// src/components/AneksPorozumienieB2B.vue